import { Component, OnInit, TemplateRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import * as _ from 'lodash';
import * as moment from 'moment';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
//import { AgGridAngular } from 'ag-grid-angular';
//import { CellClickedEvent, ColDef, GridReadyEvent } from 'ag-grid-community';
import { NgxCsvParser, NgxCSVParserError } from 'ngx-csv-parser';
import Papa  from 'papaparse';

import { environment } from 'src/environments/environment';
import { UtilService } from 'src/app/modules/shared/services/util.service';
import { SmsCampaignService } from 'src/app/modules/retailer/services/sms-campaign.service';

@Component({
  selector: 'app-create-sms-campaign',
  templateUrl: './create-sms-campaign.component.html',
  styleUrls: ['./create-sms-campaign.component.scss']
})
export class CreateSmsCampaignComponent implements OnInit {
  public pageMode: string; // add/edit
  public pageTitle: string; 

  public loginData: any;
  public editSmsCampaignDetails: any;

  public stores: any = [];
  public storeSelectionSettings: IDropdownSettings;
  public storeSelectionDisabled: boolean;

  public calendarConfig = { 
    adaptivePosition: true, 
    dateInputFormat: 'MMMM Do YYYY',  // YYYY-MM-DD | MMMM Do YYYY, h:mm:ss a
    containerClass: 'theme-default', 
    showWeekNumbers: false,
    //withTimepicker: true,
  };
  public calendarMinDate: Date;

  public campaignStores: any = [];
  public campaignName: string;
  public campaignDate: any;
  public campaignType: string; // new/existing
  public targetUserCount: number;
  public campaignSmsText: string;
  public campaignToNumberFiles: any = [];

  public existingUsers: any = [];
  public userDataCSV: any = [];
  /*public columnDefs: ColDef[] = [ // Each Column Definition results in one Column.
    { field: 'user_mobile', headerName: 'user_mobile' }
  ];
  public defaultColDef: ColDef = { // DefaultColDef sets props common to all Columns
    sortable: true,
    filter: true,
  };*/
  public customerMobileLoading = false;
  public customerCsvFiles: File[] = [];

  public savingSmsCampaign: boolean = false;
  public smsCampaignSaveConfirmModal: BsModalRef;
  public isDeleteSmsCampaign: boolean = false;
  
  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _modalService: BsModalService,
    private _utilService: UtilService,
    private _smsCampaignService: SmsCampaignService,
    private _ngxCsvParser: NgxCsvParser
  ) {
    if(this._router.getCurrentNavigation().extras.state) {
      this.editSmsCampaignDetails = this._router.getCurrentNavigation().extras.state.smsCampaign;
    }
  }

  ngOnInit(): void {
    this.getStorageData();
  }

  async getStorageData() {
    this.loginData = await this._utilService.getStorageData('R_LOGIN');

    // Calendar setings with timezone
    this.calendarMinDate = new Date(moment().format('YYYY-MM-DD HH:mm'));

    // Store selection settings
    this.storeSelectionSettings = {
      singleSelection: false,
      idField: 'store_id',
      textField: 'store_name',
      selectAllText: 'Select All Stores',
      unSelectAllText: 'UnSelect All Stores',
      //itemsShowLimit: 3,
      allowSearchFilter: false,
      enableCheckAll: false
    };
    
    if (this.editSmsCampaignDetails) { // Edit sms campaign
      this.pageMode = 'edit';
      this.pageTitle = 'Edit SMS Campaign';

      // List selected store
      let allStores = await this._utilService.getStorageData('R_RETAILERS');
      this.stores = _.filter(allStores, obj => obj.store_id == this.editSmsCampaignDetails.store_id);
      this.storeSelectionDisabled = true; // Store selection disabled
      
      this.campaignStores = this.stores;
      this.campaignName = this.editSmsCampaignDetails.campaign_name;
      this.campaignDate = new Date(moment(this.editSmsCampaignDetails.schedule_date).format('YYYY-MM-DD'));
      this.campaignSmsText = this.editSmsCampaignDetails.message;
      this.campaignType = this.editSmsCampaignDetails.target_type;
      this.targetUserCount = this.editSmsCampaignDetails.no_of_users;
      ////this.campaignToNumberFiles = [];


      /*for(let i=0; i<=this.editCircularDetails.circular.images.length - 1; i++) {
        this.circularImageFilesSelected.push({
          id: this.editCircularDetails.circular.images[i].image_id,
          file: null,
          file_base64: null,
          file_s3: this.editCircularDetails.circular.images[i].name
        })
      }*/
    } else { // Add sms circular
      this.pageMode = 'add';
      this.pageTitle = 'Create SMS Campaign';

      // List all stores
      this.stores = await this._utilService.getStorageData('R_RETAILERS');
      this.storeSelectionDisabled = false; // Store selection enabled

      this.campaignStores = [];
      this.campaignName = '';
      this.campaignDate = new Date(moment().format('YYYY-MM-DD'));
      this.campaignSmsText = '';
      this.campaignType = 'new'; // Default
      this.targetUserCount = 0;
      this.campaignToNumberFiles = [];

      this.customerMobileLoading = false;
      this.existingUsers = [];
      this.userDataCSV = [];
    }
  }

  // Back to coupons report
  onBackClick(){
    this._router.navigate(['/retailer/sms-campaign'], {
      state: {}
    });
  }

  // On Store select
  onStoreSelect(store: any) {
    if (this.campaignType == 'new') { // New - One store selection at a time
      if (this.campaignStores.length == 0) {
        this.campaignStores.push(store);
      } else {
        this.campaignStores = [];
        this.campaignStores.push(store);
      }
    } else { // Existing - Multiple store selection
      // Check if selected store exists
      let tempSelectedStore = _.filter(this.campaignStores, obj => obj.store_id != store.store_id);
      if (tempSelectedStore.length == 0) {
        this.campaignStores.push(store);
      }

      if (this.campaignStores.length > 0) {
        this.findExistingusers();
      }
    }
  }

  // On Store deselect
  onStoreDeSelect(store: any) {
    this.campaignStores = _.filter(this.campaignStores, obj => obj.store_id != store.store_id);

    if (this.campaignType == 'existing' && this.campaignStores.length > 0) {
      this.findExistingusers();
    }
  }

  // On calendar value change
  onCalendarValueChange(event: any) {
    // Update campaign date
    if (event) {
      this.campaignDate = event;
    }
  }

  // On campaign type change
  onCampaignTypeChange(source: string){
    if (this.pageMode == 'add') {
      if (this.campaignStores.length == 0) {
        this._utilService.showToast('Please select a store.', '', 'warning', {});
      } else {
        this.campaignType = source;
  
        // Clear multiple store selection for 'new' campaign type
        if (this.campaignType == 'new' && this.campaignStores.length > 1) {
          this.campaignStores = [];
          this._utilService.showToast("Campaign type 'New' is for single store. Please select a store.", '', 'warning', {});
        }
  
        // Reset target user data
        this.userDataCSV = [];
        this.targetUserCount = 0;
  
        if (this.campaignType == 'existing') { 
          if (this.existingUsers.length == 0) {// Get existing users
            this.customerMobileLoading = true;
  
            let getInternalSmsCampaignUsersBody: any = {
              retailer_id: this.loginData.user_details.provider_id,
              store_ids: []
            }
  
            // Add all stores
            for(let i=0; i<=this.stores.length-1; i++) {
              getInternalSmsCampaignUsersBody.store_ids.push({
                store_id: this.stores[i].store_id
              })
            }
  
            this._smsCampaignService.getInternalSmsCampaignUsers(this.loginData.token, getInternalSmsCampaignUsersBody).subscribe(async getInternalSmsCampaignUsersResponse => {
              this.customerMobileLoading = false;
        
              if (getInternalSmsCampaignUsersResponse.status === true) { // Success
                this.existingUsers = getInternalSmsCampaignUsersResponse.users;
  
                this.findExistingusers();
              } else {
                this._utilService.showToast(getInternalSmsCampaignUsersResponse.message, '', 'error', {});
              }
            }, error => { // Error from getInternalSmsCampaignUsers
              this.customerMobileLoading = false;
            });
          } else { // Existing users data already taken
            this.findExistingusers();
          }
        }
      }
    } else {
      this._utilService.showToast('Campaign type cannot be edited.', '', 'warning', {});
    }
  }

  // Find selected stores existing users
  findExistingusers() {
    // Create selected stores id array
    const campaignStoresArray = this.campaignStores.map((store) => store.store_id);

    // Filter users for selected store id
    const selectedStoresExistingUsers = this.existingUsers.filter((item) => {
      return campaignStoresArray.includes(item.store_id);
    });
    
    // Careate array with 'user_mobile' field
    this.userDataCSV = selectedStoresExistingUsers.map((user) => {
      return {
        user_mobile: user.user_mobile,
      };
    });
    this.targetUserCount = this.userDataCSV.length
  }

  // On csv file select for new campaign type
  onCsvSelect(event) {
    // Remove files if exists
    if(this.customerCsvFiles && this.customerCsvFiles.length >=1) {
      this.onCsvRemove(this.customerCsvFiles[0]);
    }

    let selectedFile: any = event.addedFiles[0];
    let selectedFileName: any = selectedFile.name.split('.');

    if (selectedFileName.length > 2) {
      this._utilService.showToast("CSV file name should not have '.' in it", '', 'warning', {});
    } else if (selectedFileName.length === 2 && (selectedFileName[1].toLowerCase() === "csv")) {
      // Parse file
      this._ngxCsvParser.parse(selectedFile, { header: true, delimiter: ',' }).pipe().subscribe((result: Array<any>) => {
        // Check if CSV Format is correct
        let csvFileStatus: boolean = true;
        let csvFileError: string;

        for (let i = 0; i <= result.length - 1; i++) {
          if (!result[i].hasOwnProperty('user_mobile')) {
            csvFileError = 'Invalid data in row ' + +(i + 2);
            csvFileStatus = false;
            break;
          }
        }

        if (csvFileStatus) {
          this.userDataCSV = result;
          this.targetUserCount = this.userDataCSV.length
        } else {
          this._utilService.showToast(csvFileError, '', 'error', {});
        }
      }, (error: NgxCSVParserError) => {
        this._utilService.showToast('Error', '', 'error', {});
      });
    } else {
      this._utilService.showToast('Please select .csv file', '', 'warning', {});
    }
  }

  // On csv file remove
  onCsvRemove(event) {
    this.customerCsvFiles.splice(this.customerCsvFiles.indexOf(event), 1);

    this.userDataCSV = [];
    this.targetUserCount = 0
  }

  // On save sms campaign click
  onSaveSmsCampaignClick(template: TemplateRef<any>) {
    // Validations
    if(!this.campaignName) { // Campaign Name
      this._utilService.showToast('Please enter campaign name', '', 'warning', {});
      return false;
    }

    if(this.campaignStores.length == 0) { // Stores
      this._utilService.showToast('Please select a store', '', 'warning', {});
      return false;
    }

    if(!this.campaignType) { // Campaign Type
      this._utilService.showToast('Please select campaign type', '', 'warning', {});
      return false;
    }

    if(this.pageMode == 'add' && this.userDataCSV.length == 0) { // Targeted Users for add campaign
      this._utilService.showToast('Targeted users not found', '', 'warning', {});
      return false;
    }

    if(!this.campaignDate) { // Campaign Date
      this._utilService.showToast('Please select campaign date', '', 'warning', {});
      return false;
    }

    if(!this.campaignSmsText) { // SMS Text
      this._utilService.showToast('Please enter sms text', '', 'warning', {});
      return false;
    } else if (this.campaignSmsText.length > 160) { 
      this._utilService.showToast('SMS text should be less than or equal to 160 characters', '', 'warning', {});
      return false;
    }

    this.smsCampaignSaveConfirmModal = this._modalService.show(template, {class: 'modal-sm', ignoreBackdropClick: true});
  }

  // On delete sms campaign click
  onDeleteSmsCampaignClick(template: TemplateRef<any>) {
    if (this.pageMode == 'edit') {
      this.isDeleteSmsCampaign = true; // Enable delete mode
      this.smsCampaignSaveConfirmModal = this._modalService.show(template, {class: 'modal-sm', ignoreBackdropClick: true});
    }
  }

  // Submit sms campaign
  async submitSmsCampaign() {
    alert('Coming soon...')
    /*this.savingSmsCampaign = true;
    
    if (this.pageMode == 'add') {
      // Upload csv files to S3
      let csvFileFolder: string = this.loginData.user_details.provider_type + this.loginData.user_details.provider_id + '/' + environment.cloud_storage_folder_sms_campaigns + '/';
      for(let i=0; i<=this.campaignStores.length-1; i++) {
        // Prepare mobile number csv file
        let tempData = [
          ['user_mobile']
        ]
        if (this.campaignType == 'new') { // New - Take all mobile numbers in grid (always single store)
          for (let j=0; j<=this.userDataCSV.length-1; j++) {
            // FORMAT MOBILE NO HERE
            let formattedMobileNumber = this._utilService.formatmobileNumber(this.userDataCSV[j].user_mobile)
            if (formattedMobileNumber) {
              tempData.push([formattedMobileNumber]);
            }
          }
        } else { // Existing - Take mobile number based on store (can be multiple stores)
          let tempStoreExistingUsers = _.filter(this.existingUsers, obj => obj.store_id == this.campaignStores[i].store_id);
          for (let j=0; j<=tempStoreExistingUsers.length-1; j++) {
            tempData.push([tempStoreExistingUsers[j].user_mobile]);
          }
        }
        const tempCsv = Papa.unparse(tempData);
        const tempCsvBlob = new Blob([tempCsv], { type: 'text/csv;charset=utf-8;' });

        if (tempData.length > 1) { // Upload file only if user exists
          let csvFileFolderResponse: any = await this._utilService.s3CsvFileUpload(tempCsvBlob, environment.s3_bucket, csvFileFolder, this.campaignStores[i].store_id + '-');
          if(csvFileFolderResponse.status == true){ // Upload success
            this.campaignToNumberFiles.push({ // Store upload file details
              store_id: this.campaignStores[i].store_id,
              file_name: csvFileFolderResponse.fileName,
              no_of_users: tempData.length - 1 // Remove header count 
            });
          } else { // Upload Error
            this._utilService.showToast('Error while uploading csv file', '', 'error', {});
            this.savingSmsCampaign = false;
            break;
          }
        }
      }

      this.createSmsCampaign();
    } else if (this.pageMode == 'edit') {
      this.updateSmsCampaign();
    }*/
  }

  // Create sms campaign
  createSmsCampaign() {
    try {
      let createSMSCampaignBody: any = {
        retailer_id: this.loginData.user_details.provider_id,
        user_id: this.loginData.user_details.user_id,
        schedule_date: moment(this.campaignDate).format('YYYY-MM-DD') + ' 09:00:00.000', // 9 AM
        campaign_name: this.campaignName.replace("'","''''"),
        target_type: this.campaignType,
        message: this.campaignSmsText.replace("'","''''"),
        to_number_file: this.campaignToNumberFiles
      }
      
      this._smsCampaignService.createSMSCampaign(this.loginData.token, createSMSCampaignBody).subscribe(async createSMSCampaignResponse => {
        this.savingSmsCampaign = false;

        if (createSMSCampaignResponse.status === true) { // Success
          this.hideSmsCampaignSaveConfirmModal(); // Close modal

          this._utilService.showToast('SMS campaign created successfully', '', 'success', {});
          this._router.navigate(['/retailer/sms-campaign']); // Go to sms campaign list
        } else {
          this._utilService.showToast(createSMSCampaignResponse.message, '', 'error', {});
        }
      }, error => { // Error from createSMSCampaign
        this.savingSmsCampaign = false;
      });
    } catch (err) {
      this.savingSmsCampaign = false;
      this._utilService.showToast('Error while creating sms campaign', '', 'error', {});
    }
  }

  // Update sms campaign
  updateSmsCampaign() {
    try {
      let updateSMSCampaignBody: any = {
        campaign_id: this.editSmsCampaignDetails.campaign_id,
        retailer_id: this.editSmsCampaignDetails.retailer_id,
        store_id: this.editSmsCampaignDetails.store_id,
        user_id: this.loginData.user_details.user_id,
        schedule_date: moment(this.campaignDate).format('YYYY-MM-DD') + ' 09:00:00.000', // 9 AM
        campaign_name: this.campaignName.replace("'","''''"),
        message: this.campaignSmsText.replace("'","''''"),
      }
      console.log(updateSMSCampaignBody)
      this._smsCampaignService.updateSMSCampaign(this.loginData.token, updateSMSCampaignBody).subscribe(async updateSMSCampaignResponse => {
        this.savingSmsCampaign = false;

        if (updateSMSCampaignResponse.status === true) { // Success
          this.hideSmsCampaignSaveConfirmModal(); // Close modal

          this._utilService.showToast('SMS campaign updated successfully', '', 'success', {});
          this._router.navigate(['/retailer/sms-campaign']); // Go to sms campaign list
        } else {
          this._utilService.showToast(updateSMSCampaignResponse.message, '', 'error', {});
        }
      }, error => { // Error from updateSMSCampaign
        this.savingSmsCampaign = false;
      });
    } catch (err) {
      this.savingSmsCampaign = false;
      this._utilService.showToast('Error while updating sms campaign', '', 'error', {});
    }
  }

  // Delete sms campaign
  async deleteSmsCampaign() {
    this.savingSmsCampaign = true;

    let cancelSMSCampaignBody: any = {
      campaign_id: this.editSmsCampaignDetails.campaign_id,
      retailer_id: this.loginData.user_details.provider_id,
	    store_id: this.editSmsCampaignDetails.store_id,
      user_id: this.loginData.user_details.user_id
    }

    this._smsCampaignService.cancelSMSCampaign(this.loginData.token, cancelSMSCampaignBody).subscribe(async cancelSMSCampaignResponse => {
      this.savingSmsCampaign = false;

      if (cancelSMSCampaignResponse.status === true) { // Success
        this.hideSmsCampaignSaveConfirmModal(); // Close modal

        this._utilService.showToast('SMS campaign deleted successfully', '', 'success', {});
        this._router.navigate(['/retailer/sms-campaign']); // Go to sms campaign list
      } else {
        this._utilService.showToast(cancelSMSCampaignResponse.message, '', 'error', {});
      }
    }, error => { // Error from cancelSMSCampaign
      this.savingSmsCampaign = false;
    });
  }

  // Hide sms campaign save confirm modal
  hideSmsCampaignSaveConfirmModal(): void {
    this.isDeleteSmsCampaign = false; // Disable delete mode
    this.smsCampaignSaveConfirmModal.hide();
  }

}
